import { readsApi, writesApi } from './api';
import type { Rider, DeliveryAssignment, PaginatedResponse } from '@apptypes/index';

export interface ListRidersParams {
  status?: string;
  tier?: string;
  availability?: string;
  businessId?: string;
  search?: string;
  page?: number;
  limit?: number;
}

export interface ListRiderDeliveriesParams {
  status?: string;
  page?: number;
  limit?: number;
}

export interface OnlineRider {
  id:             string;
  userId:         string;
  displayName:    string;
  phone:          string | null;
  vehicleType:    string;
  riderTier:      string;
  availability:   string;
  latitude:       number;
  longitude:      number;
  lastLocationAt: string | null;
}

export interface RiderAvailabilityStats {
  lastSeenAt:           string | null;
  totalSessionsAllTime: number;
  sessionsThisWeek:     number;
  hoursOnlineThisWeek:  number;
  sessionsLast30Days:   number;
  hoursOnlineLast30Days:number;
  avgSessionMinutes:    number;
  dailyBreakdown: { date: string; hoursOnline: number }[];
}

export const ridersService = {
  // Reads → FastAPI :8000
  list: (params?: ListRidersParams) =>
    readsApi.get<PaginatedResponse<Rider>>('/admin/riders', params as Record<string, unknown>),

  get: (riderId: string) =>
    readsApi.get<Rider>(`/admin/riders/${riderId}`),

  listDeliveries: (riderId: string, params?: ListRiderDeliveriesParams) =>
    readsApi.get<PaginatedResponse<DeliveryAssignment>>(
      `/admin/riders/${riderId}/deliveries`,
      params as Record<string, unknown>,
    ),

  availabilityStats: (riderId: string) =>
    readsApi.get<RiderAvailabilityStats>(`/admin/riders/${riderId}/availability-stats`),

  // Actions → Spring Boot :8080
  verify: (riderId: string) =>
    writesApi.post(`/admin/riders/${riderId}/verify`),

  suspend: (riderId: string, reason: string) =>
    writesApi.post(`/admin/riders/${riderId}/suspend`, { reason }),

  reinstate: (riderId: string) =>
    writesApi.post(`/admin/riders/${riderId}/reinstate`),

  upgrade: (riderId: string) =>
    writesApi.post(`/admin/riders/${riderId}/upgrade`),

  downgrade: (riderId: string) =>
    writesApi.post(`/admin/riders/${riderId}/downgrade`),

  deactivate: (riderId: string) =>
    writesApi.post(`/admin/riders/${riderId}/deactivate`),

  getOnlineRiders: () =>
    readsApi.get<{ data: OnlineRider[]; total: number }>('/admin/riders/online'),
};
